import { render, staticRenderFns } from "./WebDeveloper.vue?vue&type=template&id=837e03ce"
import script from "./WebDeveloper.vue?vue&type=script&lang=js"
export * from "./WebDeveloper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports